<template>
    <div id="loading">
        <clip-loader
        class="prompt-loader"
        :loading="true"
        color="#949494"
        size="100px"
      ></clip-loader>
      <b class="prompt-header">
        <br />{{ message }}
      </b>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import { mapState } from "vuex";

export default {
    name: 'PaymentMethodsLoader',
    props: {
        message: String
    },
    components: {
        ClipLoader
    },
    computed: {
        ...mapState(['loaderOpen']),
    },
    methods: {
        stepCurrentProgress: function() {
            const it = this.loader.progressSteps[Symbol.iterator]();
            const int = setInterval(() => {
                const next = it.next();
                if (!next.done) {
                this.loader.currentStep = next.value;
                } else {
                clearInterval(int);
                }
            }, this.loader.stepCount);
        },
    },
    watch: {
        loaderOpen: {
            handler(newVal) {
                if (newVal == false) {
                    this.$parent.close();
                }
            }
        }
    },
    data: function() {
        return {
            loader: {
                stepCount: 2500,
                backgroundColor: "linear-gradient(to right, lightgray, gray)",
                opacity: 0.5,
                spinnerSize: "22px",
                spinnerColor: "#485DC5",
                currentStep: "Connecting to our partners.",
                progressSteps: ["Reserving flights.", "Preparing checkout."]
            },
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

#loading {
  margin: auto;
  padding: 2em 5em;
  padding-bottom: 1em;
  border-radius: 8px;
  display: flex;
  max-width: 350px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .heading {
    margin-top: 0.75em;
    font-family: "Helvetica Neue";
    font-size: 1.6em;
    font-weight: bold;
    white-space: nowrap;
  }
}
.prompt-loader {
  margin-top: 3rem;
}
.prompt-header {
  font-size: 1em;
  text-align: center;
  color: #555555;
  margin-top: 1rem;
  padding: 1rem;
  span {
    font-size: 1.2em;
    font-style: normal;
    font-weight: bold;
    color: $primary-color;
    line-height: 1.6em;
  }
}
    
</style>